<h5>{{ data.titre }}</h5>
<div class="col-md-12">
  <mat-divider></mat-divider>
</div>
<div *ngIf="bcLineForm">
  <form focusInvalidInput class="row" [formGroup]="bcLineForm" (ngSubmit)="submit()"
    style="display: flex; justify-content: space-between;">
    <h6>Article</h6>
    <div class="col-md-12 data-class">
      <div class="d-flex" id="row-articles">
        <mat-form-field>
          <mat-label>Destination</mat-label>
          <mat-select formControlName="destination">
            <mat-option [value]="destination" *ngFor="let destination of this.referentiel.destinations">{{getString(destination)}}</mat-option>
          </mat-select>
          <mat-error>
            Veuillez saisir une destination
          </mat-error>
        </mat-form-field>

        <app-autocomplete-with-code-libelle-form class="w-50" id="famille" [objets]="this.referentiel.familles"
        [parent]="bcLineForm" libelle="Familles" codeControlName="codeFamille"
        libelleControlName="libelleFamille" placeholder="Famille" > 
        </app-autocomplete-with-code-libelle-form>

        <app-autocomplete-with-code-libelle-form class="w-50" id="ssFamille" [objets]="this.referentiel.ssFamilles"
        [parent]="bcLineForm" libelle="Sous Famille" codeControlName="codeSsFamille"
        libelleControlName="libelleSsFamille" placeholder="sous Famille" > 
        </app-autocomplete-with-code-libelle-form>

      </div>
      <div class="d-flex" id="row-articles">
        <app-autocomplete-with-code-libelle-form class="w-50" id="article" [objets]="this.referentiel.categories"
          [parent]="bcLineForm" libelle="Catégorie" codeControlName="codeCategorie"
          libelleControlName="libelleCategorie" placeholder="Catégorie" > 
        </app-autocomplete-with-code-libelle-form>

        <mat-form-field>
          <mat-label>Désignation</mat-label>
          <input matInput name="nth-ref-Désignation" placeholder="Désignation" formControlName="libelle">
          <mat-error>
            Veuillez saisir une désignation
          </mat-error>
        </mat-form-field>

      </div>
      <div class="d-flex" id="row-articles">
        <mat-form-field class="" id="Qte">
          <mat-label>Qte</mat-label>
          <input matInput type="number" maxlength="30" name="nth-ref-qte" placeholder="QTE" required
            formControlName="qte">
          <ng-template #qteOk>
            <input matInput type="number" maxlength="30" name="nth-ref-qte" placeholder="QTE  " required
              formControlName="qte">
          </ng-template>
          <mat-error>
            Veuillez saisir une quantité positive
          </mat-error>
        </mat-form-field>

        <mat-form-field class="">
          <mat-label>PU</mat-label>
          <input matInput type="number" maxlength="30" name="nth-ref-pu" placeholder="PU  " required
            formControlName="pu" step="0.01" lang="fr">
          <mat-icon matSuffix style="color: gray !important; font-size: 14px !important;">euro_symbol
          </mat-icon>
          <mat-error>
            Veuillez saisir un prix unitaire
          </mat-error>
        </mat-form-field>

        <mat-form-field class="" id="HT">
          <mat-label>HT</mat-label>
          <input matInput type="number" placeholder="HT" formControlName="ht" lang="fr">
          <mat-icon matSuffix style="color: gray !important; font-size: 14px !important;">euro_symbol
          </mat-icon>
        </mat-form-field>

        <app-tva-field-autocomplete class="" [parentForm]="bcLineForm" libelle="TVA" codeControlName="codeTva"
          libelleControlName="libelleTva" tauxControlName="tauxTva" placeholder="TVA" [objets]="this.referentiel.tvas">
        </app-tva-field-autocomplete>
      </div>
    </div>

    <h6>Élements financiers</h6>
    <div class="col-md-12 data-class" id="row-ef">

      <div class="subrow-ef">
        <app-autocomplete-with-code-libelle-form class="" [parent]="bcLineForm" libelle="CA1" codeControlName="codeCa1"
          libelleControlName="libelleCa1" placeholder="CA1" [objets]="this.referentiel.ca1s">
        </app-autocomplete-with-code-libelle-form>

        <app-autocomplete-with-code-libelle-form class="" [parent]="bcLineForm" libelle="NA" codeControlName="codeNa"
          libelleControlName="libelleNa" placeholder="NA" [objets]="this.referentiel.nas">
        </app-autocomplete-with-code-libelle-form>

        <app-autocomplete-with-code-libelle-form class="" [parent]="bcLineForm" libelle="CG Charge"
          codeControlName="codeCgCharge" libelleControlName="libelleCgCharge" placeholder="CG" [objets]="[]">
        </app-autocomplete-with-code-libelle-form>
      </div>

      <div class="subrow-ef">
        <app-autocomplete-with-code-libelle-form class="" [parent]="bcLineForm" libelle="CA2" codeControlName="codeCa2"
          libelleControlName="libelleCa2" placeholder="CA2" [objets]="this.referentiel.ca2s">
        </app-autocomplete-with-code-libelle-form>

        <app-autocomplete-with-code-libelle-form class="" [parent]="bcLineForm" libelle="Complément"
          codeControlName="codeComp" libelleControlName="libelleComp" placeholder="Complément"
          [objets]="this.referentiel.comps">
        </app-autocomplete-with-code-libelle-form>

        <mat-form-field>
          <mat-label>Date livraison</mat-label>
          <input matInput [matDatepicker]="pickerDLivr" name="nth-date-bc-l" [min]="minDateLiv"
            formControlName="dLivraison">
          <mat-datepicker-toggle matSuffix [for]="pickerDLivr"></mat-datepicker-toggle>
          <mat-datepicker #pickerDLivr></mat-datepicker>
          <mat-error *ngIf="bcLineForm.get('dLivraison').hasError('matDatepickerMin')">
            Veuillez sélectionner une date égale ou supérieur à la date du jour
          </mat-error>
        </mat-form-field>
      </div>


    </div>


    <div id="row-autres">
      <h6>Autres</h6>
      <div class="d-flex">
        <div class="d-flex data-class">
          <mat-form-field matTooltip="Numéro de BC / chantier JASON limité à 13 caractères">
            <mat-label>Chantier</mat-label>
            <input matInput name="nth-ref-libelle" placeholder="Chantier" formControlName="chantier">
            <mat-error *ngIf="bcLineForm.get('chantier').hasError('maxlength')">
              Nombre maximum de caractère dépassé.
            </mat-error>
            <mat-error *ngIf="bcLineForm.get('chantier').hasError('pattern')">
              Le format est incorrect (exemple : 12117709.1)
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Équipement</mat-label>
            <input matInput name="nth-ref-libelle" maxlength="12" placeholder="Equipement  " formControlName="vehicule">
          </mat-form-field>
        </div>
        <div>
          <button mat-raised-button color="default" type="button" (click)="cancel()">Annuler</button>
        </div>
        <div>
          <button mat-raised-button color="primary" type="submit">Confirmer</button>
        </div>
      </div>

    </div>
  </form>
</div>
